import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import SchoolFields from './SchoolFields'

export const SchoolCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <SchoolFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default SchoolCreate
